<template>
  <div class="full">
    <!-- <Pipeline ref="pipeline" style="width: 100%; height: 100%;" v-if="toucher" :toucher="toucher" :useBloom="useBloom" :bloomPass="bloomPass"> -->
      <!-- <template slot-scope="temp" slot="scene"> -->
        <!-- <Particles :amount="200" v-if="temp" :engine="temp"></Particles> -->
        <!-- <LoadingGL :visible="true" @add-exec="(fn) => { temp.execStack.push(fn) }" :scene="temp.scene" :exec="temp.execStack" :renderer="temp.renderer"></LoadingGL> -->
      <!-- </template> -->
    <!-- </Pipeline> -->
    <BGTemplate class="cg-layer full" :bloom="'bubbles'" @ready="(v) => { engine = v; }">
    </BGTemplate>
    <BlueBubbles v-if="engine && engine.renderer && engine.scene && engine.camera" :camera="engine.camera" :amount="20" :renderer="engine.renderer" :scene="engine.scene"></BlueBubbles>
    <Toolbar></Toolbar>


    <div class="overlay" ref="toucher"></div>
    <div class="overlay" v-if="authMode === 'login'">

      <h2 class="center ">Welcome to</h2>
      <h1 class="center welcome">Instructor's Dashboard</h1>
      <div class="center">
        <input class="text-input white-text" placeholder="Username" type="text" v-model="loginData.username" />
        <br />
        <input  class="text-input white-text" placeholder="Password" type="password" v-model="loginData.password" />
        <br />

        <div class="between">
          <button class="click btn-both btn-weaker" @click="authMode = 'register'">Switch to Register</button>
          <button class="click btn-both" @click="login()">Login</button>
        </div>
      </div>
    </div>
    <div class="overlay" v-if="authMode === 'register'">
      <h2 class="center">Welcome to</h2>
      <h1 class="center welcome">Instructor's Dashboard</h1>
      <div class="center">
        <input class="text-input white-text" placeholder="Username" type="text" v-model="loginData.username" />
        <br />
        <input  class="text-input white-text" placeholder="Password" type="password" v-model="loginData.password" />
        <br />
        <div class="between">
          <button class="click btn-both btn-weaker" @click="authMode = 'login'">Switch to Login</button>
        <button class="click btn-both" @click="register()">Register</button>

        </div>
        <span class="errmsg" v-if="errMsg"><br />{{ errMsg }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as Teacher from '@/api/teacher.js'
export default {
  components: {
    Toolbar: () => import(/* webpackChunkName: "cloud" */ '../ui/Toolbar.vue'),
    BlueBubbles: () => import(/* webpackChunkName: "cloud" */ '../game/BlueBubbles.vue'),
    BGTemplate: () => import(/* webpackChunkName: "cloud" */ '../game/BGTemplate.vue')
    // Pipeline: require('../game/Pipeline.vue').default,
    // Particles: () => import('../game/Particles.vue'),
    // LoadingGL: () => import('../game/LoadingGL.vue'),
    // LoadingGL: require('../game/LoadingGL.vue').default
  },
  data () {
    return {
      engine: false,
      errMsg: '',
      authMode: 'register',
      loginData: {
        username: '',
        password: ''
      },
      toucher: false,
      useBloom: true,
      bloomPass: {
        threshold: 1,
      }
    }
  },
  mounted () {
    this.toucher = this.$refs.toucher
  },
  methods: {
    login () {
      this.errMsg = ''
      let args = this.loginData
      Teacher.login(args)
        .then((data) => {
          window.localStorage.setItem('teacher-jwt', data.token)
          window.localStorage.setItem('teacher-uid', data.user._id)

          this.$router.push({
            path: '/buhk-cloud/teacher',
            query: {
              ...this.$route.query,
            }
          })
        }, () => {
          this.errMsg = 'Bad Login Credentials'
        })
    },
    register () {
      this.errMsg = ''
      let args = this.loginData
      Teacher.register(args)
        .then((data) => {
          console.log(data)
          window.localStorage.setItem('teacher-jwt', data.token)
          window.localStorage.setItem('teacher-uid', data.user._id)

          this.$router.push({
            path: '/buhk-cloud/teacher',
            query: {
              ...this.$route.query,
            }
          })
        }, () => {
         this.login()
          window.alert('trying to login....')
        })

    }
  }
}
</script>

<style scoped>
.overlay{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  color: white;
  /* background-color: red; */
}
.text-input{
  appearance: none;
  box-shadow: none;
  outline: none;
  border: none;
  background-color: white;
  border-bottom: white solid 3px;
  font-size: 30px;
  padding: 10px;
  margin: 10px;
}
.center{
  text-align: center;
}
.errmsg{
  color: red;
}

.welcome{
  color: #386EE2;
}

 .text-input{
  padding: 12px 12px;
  width: 250px;
  appearance: none;
  margin: 10px 0px;
  background: #595D66;
  border: #595D66 solid 2px;
  border-radius: 10px;
  outline: none;
  box-shadow: none;
  position:relative;
}
.text-input::placeholder{
  color: rgb(218, 224, 240);
}



 .btn-both{
  appearance: none;
  width: 160px;
  margin: 8px 20px 8px 0px;
  padding: 8px 30px;
  background: #537EF4;
  color:white;
  border-radius: 10px;
  border: #7093F4 solid 2px;
  outline: none;
  box-shadow: none;
  }
  .btn-weaker{
    width: 100px;
    background: hsl(224, 77%, 72%);
  }
  .between{
    margin: 0px auto;
    width: 300px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .white-text{
    color: white;
  }
</style>
